// GENERATED by packages/tools/src/wordmark/bake.mjs from Jost (src/fonts/jost-variable.woff2). Do not edit.
//
// The wordmark's letters at every x-height it grows through, one string per pixel row, each digit how
// much of that pixel the letter covers in tenths (9 is 90% or more). Each letter is h + 2 rows: a row
// above the x-height and one below the baseline hold the round letters' overshoot.

export const GLYPHS: Record<number, Record<string, string[]>> = {
    // x-height 12, Jost 400
    12: {
        s: [
            "0001320000",
            "0189999600",
            "0898679970",
            "1990003950",
            "0994000000",
            "0699720000",
            "0069998300",
            "0001599940",
            "0000006991",
            "0520000992",
            "5992001991",
            "0899879970",
            "0069999600",
            "0000220000",
        ],
        a: [
            "000013320000",
            "004899999500",
            "029986679950",
            "005200005990",
            "000000001990",
            "000245421990",
            "018999999990",
            "089832247990",
            "199100002990",
            "299000004990",
            "199400029990",
            "069976899990",
            "006999962990",
            "000022000000",
        ],
        m: [
            "010002310000232000",
            "299299996028999700",
            "299997899699789960",
            "299700069981004990",
            "299100019930000992",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "299000009910000893",
            "000000000000000000",
        ],
        r: [
            "0100320",
            "9949997",
            "9998793",
            "9970010",
            "9930000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "9920000",
            "0000000",
        ],
    },
    // x-height 13, Jost 388
    13: {
        s: [
            "00013320000",
            "00699998300",
            "06997799940",
            "09930007950",
            "09940000100",
            "07995000000",
            "01899961000",
            "00049999500",
            "00000389950",
            "00000006990",
            "16500002990",
            "49950006980",
            "06999899930",
            "00499999300",
            "00002220000",
        ],
        a: [
            "000002332000",
            "002799999930",
            "009997669993",
            "004500000798",
            "000000000399",
            "000001100299",
            "001799997599",
            "029997679999",
            "079700000499",
            "099300000399",
            "099300000799",
            "089800005999",
            "039997799899",
            "003999994299",
            "000022200000",
        ],
        m: [
            "0110013300000232000",
            "0992799994028999920",
            "0998987999499889990",
            "0999300199981002994",
            "0995000049920000796",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0992000039900000597",
            "0000000000000000000",
        ],
        r: [
            "011003310",
            "099389992",
            "099997970",
            "099800010",
            "099400000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "099200000",
            "000000000",
        ],
    },
    // x-height 14, Jost 375
    14: {
        s: [
            "000013320000",
            "001799998300",
            "008997799950",
            "029910017980",
            "039900000400",
            "019960000000",
            "006999510000",
            "000499996100",
            "000004899920",
            "000000039990",
            "001000002992",
            "059300001992",
            "079940005990",
            "008999899940",
            "000599999400",
            "000002320000",
        ],
        a: [
            "000013331000",
            "004999999820",
            "079997679992",
            "028300001997",
            "000000000599",
            "000000000399",
            "001467752399",
            "049999999999",
            "299721124899",
            "698000000399",
            "895000000599",
            "896000000999",
            "599300017999",
            "099987899799",
            "017999982399",
            "000122100000",
        ],
        m: [
            "0100033200000232000",
            "9934999971039999930",
            "9979989997399889991",
            "9996000599981002995",
            "9970000099910000698",
            "9940000079700000499",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "9930000069600000399",
            "0000000000000000000",
        ],
        r: [
            "01002320",
            "99479996",
            "99998993",
            "99920020",
            "99600000",
            "99400000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "99300000",
            "00000000",
        ],
    },
    // x-height 15, Jost 363
    15: {
        s: [
            "000012200000",
            "004999996000",
            "049987899910",
            "089500028970",
            "099100001500",
            "099500000000",
            "059972000000",
            "006999730000",
            "000279998200",
            "000001599920",
            "000000018980",
            "010000003990",
            "496000002990",
            "399610007970",
            "049998799920",
            "003899998200",
            "000012210000",
        ],
        a: [
            "00000123200000",
            "00059999997100",
            "01999876899910",
            "00772000018970",
            "00000000003990",
            "00000000002990",
            "00000121001990",
            "00179999974990",
            "02999655699990",
            "08960000004990",
            "29910000002990",
            "39900000004990",
            "29910000008990",
            "09970000179990",
            "03999767994990",
            "00389999711990",
            "00001321000000",
        ],
        m: [
            "0000002220000002210000",
            "0992289998200499998100",
            "0994998899914998999900",
            "0999710029979600039950",
            "0998000004997000006980",
            "0994000002993000003990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0992000001991000002990",
            "0000000000000000000000",
        ],
        r: [
            "0000012200",
            "0992599980",
            "0997988960",
            "0999200200",
            "0996000000",
            "0993000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0000000000",
        ],
    },
    // x-height 16, Jost 350
    16: {
        s: [
            "0000023210000",
            "0004999997100",
            "0059987899930",
            "0099400018991",
            "0299000000730",
            "0299100000000",
            "0089820000000",
            "0029997300000",
            "0001799994000",
            "0000016999810",
            "0000000049980",
            "0000000003993",
            "0040000000994",
            "0895000000993",
            "0499600006990",
            "0059998799930",
            "0003899998300",
            "0000013310000",
        ],
        a: [
            "00000023320000",
            "00037999999600",
            "00799976799980",
            "00594000004995",
            "00000000000598",
            "00000000000399",
            "00000000000299",
            "00015788752299",
            "00499999999899",
            "03996200024899",
            "08960000000299",
            "09920000000399",
            "19920000000699",
            "09940000002999",
            "06993000039999",
            "00899866898399",
            "00069999950299",
            "00000232000000",
        ],
        m: [
            "00000013200000002310000",
            "09921799995000699997100",
            "09939988999507998999800",
            "09988100079959400049950",
            "09990000019994000006980",
            "09950000007990000003990",
            "09920000006970000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "09920000006960000002990",
            "00000000000000000000000",
        ],
        r: [
            "0000003200",
            "0992499992",
            "0996988990",
            "0999300120",
            "0996000000",
            "0993000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0992000000",
            "0000000000",
        ],
    },
    // x-height 17, Jost 338
    17: {
        s: [
            "0000133200000",
            "0028999994000",
            "0399977999700",
            "0896000049960",
            "0991000003930",
            "0992000000000",
            "0897000000000",
            "0399940000000",
            "0039999620000",
            "0000599996100",
            "0000003799910",
            "0000000039970",
            "0000000004990",
            "1710000002991",
            "7980000003990",
            "2998200018960",
            "0399987899810",
            "0017999996100",
            "0000133200000",
        ],
        a: [
            "000001333200000",
            "000599999995000",
            "039999767999700",
            "019720000059950",
            "001000000006980",
            "000000000003990",
            "000000000002990",
            "000013443002990",
            "003899999974990",
            "059985445699990",
            "299400000005990",
            "697000000002990",
            "795000000004990",
            "796000000007990",
            "698000000039990",
            "299700000498990",
            "059997679973990",
            "003899999402990",
            "000013310000000",
        ],
        m: [
            "000000133100000013310000",
            "099306999981001699998100",
            "099379989999018998999910",
            "099793000399579300039960",
            "099920000059992000005990",
            "099700000029960000002991",
            "099400000009930000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "099300000009920000000992",
            "000000000000000000000000",
        ],
        r: [
            "00000033100",
            "09932999960",
            "09959989950",
            "09995000300",
            "09980000000",
            "09950000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "09930000000",
            "00000000000",
        ],
    },
    // x-height 18, Jost 325
    18: {
        s: [
            "00000133200000",
            "00038999995000",
            "00499977999810",
            "00995000039980",
            "02990000002981",
            "03990000000200",
            "01993000000000",
            "00799400000000",
            "00189995100000",
            "00005999972000",
            "00000037999600",
            "00000000179960",
            "00000000005992",
            "00000000000994",
            "05900000000894",
            "09970000001992",
            "03997100017980",
            "00499987899920",
            "00027999997200",
            "00000133310000",
        ],
        a: [
            "0000002333200000",
            "0002799999984000",
            "0079998767999600",
            "0089510000069940",
            "0011000000007980",
            "0000000000003990",
            "0000000000002990",
            "0000000000002990",
            "0002689998622990",
            "0059998889998990",
            "0599510000148990",
            "0994000000002990",
            "3990000000003990",
            "4980000000005990",
            "3990000000008990",
            "1993000000059990",
            "0799300000696990",
            "0189986679952990",
            "0006999998302990",
            "0000023310000000",
        ],
        m: [
            "0000000332000000023310000",
            "0992059999930002899997100",
            "0992699889993039987999800",
            "0995940001899197100049950",
            "0999300000199880000006990",
            "0997000000079920000002991",
            "0994000000069900000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0992000000059700000000992",
            "0000000000000000000000000",
        ],
        r: [
            "00000033200",
            "09922899981",
            "09939978980",
            "09996000210",
            "09980000000",
            "09950000000",
            "09930000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "00000000000",
        ],
    },
    // x-height 19, Jost 313
    19: {
        s: [
            "000000333100000",
            "000179999972000",
            "002999767999500",
            "008970000169940",
            "019910000006970",
            "019900000000300",
            "019930000000000",
            "007992000000000",
            "001999620000000",
            "000179998400000",
            "000002799994000",
            "000000014899700",
            "000000000059960",
            "000000000005990",
            "002000000002991",
            "079200000001991",
            "079800000004990",
            "019982000039950",
            "002999977899700",
            "000169999995000",
            "000000233200000",
        ],
        a: [
            "0000001333310000",
            "0000589999997200",
            "0049999766899940",
            "0069720000017992",
            "0003000000000996",
            "0000000000000598",
            "0000000000000399",
            "0000000000000399",
            "0000035665300399",
            "0005999999996599",
            "0079964222469999",
            "0599200000000699",
            "0994000000000399",
            "1991000000000499",
            "2991000000000799",
            "1992000000001999",
            "0896000000007999",
            "0499600000289599",
            "0069997668993399",
            "0004899999610399",
            "0000013320000000",
        ],
        m: [
            "00000002331000000023310000",
            "19910499999600004999997000",
            "19915997799970069987999800",
            "19949500005993495000059940",
            "19984000000797950000006980",
            "19980000000399800000002991",
            "19940000000199500000000992",
            "19920000000099300000000992",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "19910000000099200000000993",
            "00000000000000000000000000",
        ],
        r: [
            "00000023300",
            "09921799994",
            "09938987993",
            "09987100030",
            "09991000000",
            "09960000000",
            "09940000000",
            "09930000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "09920000000",
            "00000000000",
        ],
    },
    // x-height 20, Jost 300
    20: {
        s: [
            "000001333200000",
            "000179999994000",
            "001999767999700",
            "008970000049970",
            "019900000003992",
            "029900000000430",
            "029900000000000",
            "009960000000000",
            "004997100000000",
            "000599974000000",
            "000026999951000",
            "000000158999400",
            "000000000389950",
            "000000000006992",
            "000000000000995",
            "013000000000696",
            "199100000000795",
            "079800000001993",
            "019982000017980",
            "002999876799910",
            "000169999997100",
            "000000234310000",
        ],
        a: [
            "00000023443100000",
            "00016999999972000",
            "00699986567999400",
            "01995100000179920",
            "00310000000008960",
            "00000000000004990",
            "00000000000002990",
            "00000000000001990",
            "00000012100001990",
            "00037999999621990",
            "00799976668998990",
            "06994000000048990",
            "29920000000001990",
            "59700000000002990",
            "79500000000003990",
            "79500000000006990",
            "69700000000019990",
            "39920000000088990",
            "08993000002893990",
            "01899865689921990",
            "00069999996101990",
            "00000243200000000",
        ],
        m: [
            "000000024320000000134310000",
            "199003899998100006999996000",
            "199039977899910189977999700",
            "199296000029970793000059930",
            "199750000003994910000007970",
            "199800000000999400000003990",
            "199400000000799000000001992",
            "199100000000697000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "199000000000596000000000992",
            "000000000000000000000000000",
        ],
        r: [
            "000000243100",
            "099107999960",
            "099289779960",
            "099781000300",
            "099910000000",
            "099600000000",
            "099400000000",
            "099200000000",
            "099200000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "099100000000",
            "000000000000",
        ],
    },
}
